import { render, staticRenderFns } from "./Mach.vue?vue&type=template&id=3ebf1510&scoped=true"
import script from "./Mach.vue?vue&type=script&lang=ts"
export * from "./Mach.vue?vue&type=script&lang=ts"
import style0 from "./Mach.vue?vue&type=style&index=0&id=3ebf1510&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf1510",
  null
  
)

export default component.exports